// CategorySubcategoryView.js

import React, { useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";

import Select from "react-select";

import { FiGrid, FiLayers, FiImage, FiSave, FiCheck } from "react-icons/fi";

import styles from "./CategorySubcategoryView.module.css";

const CategorySubcategoryView = ({ categoryList = [], onSubmit }) => {
  const [formData, setFormData] = useState({
    type: {
      value: "category",
      label: "Category",
    },

    category: null,

    name: "",

    isActive: true,

    image: null,
  });

  const [preview, setPreview] = useState("");

  // ================= HANDLE INPUT =================

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ================= IMAGE =================

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      setPreview(URL.createObjectURL(file));
    }
  };

  // ================= SUBMIT =================

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      alert("Please enter name");
      return;
    }

    if (formData.type.value === "subcategory" && !formData.category) {
      alert("Please select category");
      return;
    }

    const payload = {
      type: formData.type.value,

      categoryId:
        formData.type.value === "subcategory" ? formData.category?.value : null,

      name: formData.name,

      isActive: formData.isActive,

      image: formData.image,
    };

    if (onSubmit) {
      onSubmit(payload);
    } else {
      console.log(payload);
    }
  };

  // ================= OPTIONS =================

  const typeOptions = [
    {
      value: "category",
      label: "Category",
    },

    {
      value: "subcategory",
      label: "Sub Category",
    },
  ];

  const categoryOptions =
    categoryList?.map((item) => ({
      value: item?._id,
      label: item?.name,
    })) || [];

  // ================= SELECT STYLE =================

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,

      minHeight: "44px",

      borderRadius: "12px",

      borderColor: state.isFocused ? "#6366f1" : "#e5e7eb",

      boxShadow: state.isFocused ? "0 0 0 3px rgba(99,102,241,0.10)" : "none",

      "&:hover": {
        borderColor: "#6366f1",
      },

      fontSize: "14px",
    }),

    valueContainer: (base) => ({
      ...base,
      paddingLeft: "38px",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
    }),

    menu: (base) => ({
      ...base,
      zIndex: 9999,
      borderRadius: "12px",
      overflow: "hidden",
    }),
  };

  return (
    <Card className={styles.mainCard}>
      <Card.Body className={styles.cardBody}>
        {/* ================= HEADER ================= */}

        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.iconBox}>
              {formData.type.value === "category" ? <FiGrid /> : <FiLayers />}
            </div>

            <div>
              <h5 className={styles.title}>Category Management</h5>

              <p className={styles.subtitle}>Manage category & subcategory</p>
            </div>
          </div>

          <div
            className={`${styles.status} ${
              formData.isActive ? styles.active : styles.inactive
            }`}
          >
            <FiCheck />
            {formData.isActive ? "Active" : "Inactive"}
          </div>
        </div>

        {/* ================= FORM ================= */}

        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* TYPE */}

            <Col md={4} xs={12}>
              <Form.Label className={styles.label}>Type</Form.Label>

              <div className={styles.selectWrapper}>
                <div className={styles.inputIcon}>
                  {formData.type.value === "category" ? (
                    <FiGrid />
                  ) : (
                    <FiLayers />
                  )}
                </div>

                <Select
                  value={formData.type}
                  options={typeOptions}
                  styles={customSelectStyles}
                  isSearchable={false}
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      type: selected,
                      category: null,
                    }))
                  }
                />
              </div>
            </Col>

            {/* CATEGORY */}

            {formData.type.value === "subcategory" && (
              <Col md={4} xs={12}>
                <Form.Label className={styles.label}>Main Category</Form.Label>

                <div className={styles.selectWrapper}>
                  <div className={styles.inputIcon}>
                    <FiGrid />
                  </div>

                  <Select
                    value={formData.category}
                    options={categoryOptions}
                    styles={customSelectStyles}
                    placeholder="Select Category"
                    onChange={(selected) =>
                      setFormData((prev) => ({
                        ...prev,
                        category: selected,
                      }))
                    }
                  />
                </div>
              </Col>
            )}

            {/* NAME */}

            <Col md={formData.type.value === "subcategory" ? 4 : 8} xs={12}>
              <Form.Label className={styles.label}>Name</Form.Label>

              <div className={styles.inputWrapper}>
                <div className={styles.inputIcon}>
                  {formData.type.value === "category" ? (
                    <FiGrid />
                  ) : (
                    <FiLayers />
                  )}
                </div>

                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder={`Enter ${
                    formData.type.value === "category"
                      ? "Category"
                      : "Sub Category"
                  } Name`}
                  className={styles.formControl}
                />
              </div>
            </Col>

            {/* STATUS */}

            <Col md={4} xs={12}>
              <Form.Label className={styles.label}>Status</Form.Label>

              <div className={styles.switchBox}>
                <Form.Check
                  type="switch"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                  label={formData.isActive ? "Active" : "Inactive"}
                />
              </div>
            </Col>

            {/* IMAGE */}

            <Col md={8} xs={12}>
              <Form.Label className={styles.label}>Image</Form.Label>

              <label className={styles.uploadBox}>
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageChange}
                />

                {preview ? (
                  <img
                    src={preview}
                    alt="preview"
                    className={styles.previewImage}
                  />
                ) : (
                  <div className={styles.uploadContent}>
                    <FiImage className={styles.uploadIcon} />

                    <span>Upload Image</span>
                  </div>
                )}
              </label>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default CategorySubcategoryView;
